const roundButtonStyle = (
	size: size,
	disabled: boolean,
	backgroundColour: string
) => ({
	borderRadius: '50%',
	width: `${getSize(size)}px`,
	height: `${getSize(size)}px`,
	border: 'none',
	padding: '0',
	color: 'white',
	backgroundColor: disabled ? 'gray' : backgroundColour,
});
type size = 'small' | 'medium' | 'large';
type direction = 'left' | 'right' | 'start' | 'end';
interface DirectionalButtonProps {
	direction: direction;
	onClick: () => void;
	disabled?: boolean;
	size?: size;
	backgroundColour?: string;
}

function getSize(size: size) {
	switch (size) {
		case 'small':
			return 40;
		case 'large':
			return 80;
		default:
			return 60;
	}
}
function getFontSize(size: size) {
	switch (size) {
		case 'small':
			return 2;
		case 'large':
			return 4;
		default:
			return 3;
	}
}

function getDirectionText(direction: direction) {
	switch (direction) {
		case 'left':
			return '‹';
		case 'right':
			return '›';
		case 'start':
			return '«';
		case 'end':
			return '»';
		default:
			return '';
	}
}
export default function DirectionalButton({
	direction,
	onClick,
	disabled,
	size = 'medium',
	backgroundColour = '#1c344f',
}: DirectionalButtonProps) {
	return (
		<div
			role="button"
			tabIndex={disabled ? -1 : 0}
			onClick={disabled ? undefined : onClick}
			style={{
				...roundButtonStyle(size, !!disabled, backgroundColour),
				WebkitTapHighlightColor: 'transparent',
				outline: 'none',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				cursor: disabled ? 'default' : 'pointer',
			}}
		>
			<span
				style={{
					marginLeft: '-0.05em',
					marginTop: '-0.23em',
					lineHeight: '0.5',
					fontSize: `${getFontSize(size)}vw`,
				}}
			>
				{getDirectionText(direction)}
			</span>
		</div>
	);
}
